// Patient page chrome strings (EN/ES). Form content comes from the
// definitions; the renderer's own strings live in ../engine/i18n.js.
// No staff wording, no "care" wording: this is the patient's page.

const S = {
  en: {
    docTitle: "Your forms",
    loading: "Loading your forms…",
    language: "Language",
    retry: "Try again",

    invalidTitle: "This link isn't valid",
    invalidBody: "Please check that you opened the whole link from your message.",
    expiredTitle: "This link has expired",
    cancelledTitle: "This link is no longer active",
    lockedTitle: "This link is locked",
    lockedBody: "For your security, this link was locked after too many tries.",
    completedTitle: "Already completed — thank you",
    completedBody: "Your forms were already sent. You can close this page.",
    contactPhone: "Please contact {practice} at {phone} for a new link.",
    contactNoPhone: "Please contact {practice} for a new link.",
    contactGeneric: "If you still need to fill out your forms, please contact the office for a new link.",
    rateTitle: "Too many tries",
    rateBody: "Please wait a few minutes, then try again.",
    networkTitle: "We couldn't connect",
    networkBody: "Check your internet connection and try again.",

    gateTitle: "Confirm your date of birth",
    gateIntro: "To protect your privacy, please enter your date of birth before we show your forms.",
    gateForms: "{n} forms · about {m} min",
    gateForm1: "1 form · about {m} min",
    dobLegend: "Date of birth",
    month: "Month",
    day: "Day",
    year: "Year",
    monthPh: "MM",
    dayPh: "DD",
    yearPh: "YYYY",
    continue: "Continue",
    checking: "Checking…",
    errDobIncomplete: "Enter your full date of birth.",
    errDobInvalid: "Enter a valid date of birth.",
    errDobMismatch: "That date of birth doesn't match our records.",
    triesLeft: "{n} tries left.",
    triesLeft1: "1 try left.",
    errRate: "Too many tries — please wait a few minutes and try again.",
    errNetwork: "We couldn't connect. Check your internet connection and try again.",
    sessionLost: "Please confirm your date of birth to continue — your answers are saved.",
    privacy: "Your answers are sent securely to {practice}.",
    privacyGeneric: "Your answers are sent securely to your care team.",

    hello: "Hi {name}",
    helloNoName: "Hello",
    hubIntro: "Please complete these forms before your visit.",
    hubIntro1: "Please complete this form before your visit.",
    hubProgress: "{done} of {total} complete",
    hubMinutes: "About {m} min",
    hubTotal: "About {m} minutes in total",
    statusNotStarted: "Not started",
    statusInProgress: "In progress",
    statusDone: "Completed",
    start: "Start",
    resume: "Continue",
    startNext: "Start next form",
    startFirst: "Start",
    hubSaved: "Your answers save as you go. You can stop and come back to this link later.",
    expiresOn: "This link works until {date}.",
    formsList: "Your forms",

    formOf: "Form {n} of {total}",
    allForms: "All forms",
    sending: "Sending your form…",
    sentForm: "Sent: {title}",
    submitFailed: "We couldn't send this form. Check your connection and tap Submit again.",
    submitRejected: "Some answers couldn't be accepted. Please check the form and tap Submit again.",

    doneTitle: "All done — thank you!",
    doneTitleName: "All done, {name} — thank you!",
    doneBody: "Your forms were sent to {practice}.",
    doneBodyGeneric: "Your forms were sent to your care team.",
    doneClose: "You can close this page.",
    doneKiosk: "Please return the device to the staff.",
    emergency: "If you need urgent help, call 911 or 988.",

    kioskEnded: "This session has ended.",
    close: "Close",
    exitKiosk: "Exit (staff)",
  },
  es: {
    docTitle: "Sus formularios",
    loading: "Cargando sus formularios…",
    language: "Idioma",
    retry: "Intentar de nuevo",

    invalidTitle: "Este enlace no es válido",
    invalidBody: "Revise que abrió el enlace completo de su mensaje.",
    expiredTitle: "Este enlace ha vencido",
    cancelledTitle: "Este enlace ya no está activo",
    lockedTitle: "Este enlace está bloqueado",
    lockedBody: "Por su seguridad, este enlace se bloqueó después de demasiados intentos.",
    completedTitle: "Ya completado — gracias",
    completedBody: "Sus formularios ya fueron enviados. Puede cerrar esta página.",
    contactPhone: "Comuníquese con {practice} al {phone} para recibir un enlace nuevo.",
    contactNoPhone: "Comuníquese con {practice} para recibir un enlace nuevo.",
    contactGeneric: "Si todavía necesita llenar sus formularios, comuníquese con la oficina para recibir un enlace nuevo.",
    rateTitle: "Demasiados intentos",
    rateBody: "Espere unos minutos y vuelva a intentarlo.",
    networkTitle: "No pudimos conectarnos",
    networkBody: "Revise su conexión a internet y vuelva a intentarlo.",

    gateTitle: "Confirme su fecha de nacimiento",
    gateIntro: "Para proteger su privacidad, escriba su fecha de nacimiento antes de ver sus formularios.",
    gateForms: "{n} formularios · unos {m} min",
    gateForm1: "1 formulario · unos {m} min",
    dobLegend: "Fecha de nacimiento",
    month: "Mes",
    day: "Día",
    year: "Año",
    monthPh: "MM",
    dayPh: "DD",
    yearPh: "AAAA",
    continue: "Continuar",
    checking: "Verificando…",
    errDobIncomplete: "Escriba su fecha de nacimiento completa.",
    errDobInvalid: "Escriba una fecha de nacimiento válida.",
    errDobMismatch: "Esa fecha de nacimiento no coincide con nuestros registros.",
    triesLeft: "Le quedan {n} intentos.",
    triesLeft1: "Le queda 1 intento.",
    errRate: "Demasiados intentos — espere unos minutos y vuelva a intentarlo.",
    errNetwork: "No pudimos conectarnos. Revise su conexión a internet y vuelva a intentarlo.",
    sessionLost: "Confirme su fecha de nacimiento para continuar — sus respuestas están guardadas.",
    privacy: "Sus respuestas se envían de forma segura a {practice}.",
    privacyGeneric: "Sus respuestas se envían de forma segura a su equipo médico.",

    hello: "Hola, {name}",
    helloNoName: "Hola",
    hubIntro: "Por favor complete estos formularios antes de su cita.",
    hubIntro1: "Por favor complete este formulario antes de su cita.",
    hubProgress: "{done} de {total} completados",
    hubMinutes: "Unos {m} min",
    hubTotal: "Unos {m} minutos en total",
    statusNotStarted: "Sin empezar",
    statusInProgress: "En progreso",
    statusDone: "Completado",
    start: "Empezar",
    resume: "Continuar",
    startNext: "Empezar el siguiente",
    startFirst: "Empezar",
    hubSaved: "Sus respuestas se guardan mientras avanza. Puede parar y volver a este enlace más tarde.",
    expiresOn: "Este enlace funciona hasta el {date}.",
    formsList: "Sus formularios",

    formOf: "Formulario {n} de {total}",
    allForms: "Todos los formularios",
    sending: "Enviando su formulario…",
    sentForm: "Enviado: {title}",
    submitFailed: "No pudimos enviar este formulario. Revise su conexión y toque Enviar otra vez.",
    submitRejected: "Algunas respuestas no se aceptaron. Revise el formulario y toque Enviar otra vez.",

    doneTitle: "¡Listo — gracias!",
    doneTitleName: "¡Listo, {name} — gracias!",
    doneBody: "Sus formularios fueron enviados a {practice}.",
    doneBodyGeneric: "Sus formularios fueron enviados a su equipo médico.",
    doneClose: "Puede cerrar esta página.",
    doneKiosk: "Por favor devuelva el dispositivo al personal.",
    emergency: "Si necesita ayuda urgente, llame al 911 o al 988.",

    kioskEnded: "Esta sesión terminó.",
    close: "Cerrar",
    exitKiosk: "Salir (personal)",
  },
};

export function pt(key, lang = "en", vars) {
  let s = (S[lang] && S[lang][key]) || S.en[key] || key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

export const PATIENT_STRINGS = S;

// Browser preference, used only until the request's own language is known.
export function browserLang() {
  try {
    const l = (typeof navigator !== "undefined" && (navigator.language || (navigator.languages || [])[0])) || "";
    return /^es\b/i.test(l) ? "es" : "en";
  } catch (_) {
    return "en";
  }
}

// "October 8, 2026" / "8 de octubre de 2026" for an ISO instant, in the device's zone.
export function formatDate(iso, lang = "en") {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleDateString(lang === "es" ? "es-US" : "en-US", { month: "long", day: "numeric", year: "numeric" });
  } catch (_) {
    return d.toISOString().slice(0, 10);
  }
}
